// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"1b9bc206","280":"bbf12488","449":"08354641","453":"9d2d9f10","869":"72a131af"}[chunkId] + ".chunk.js";
};